import { Divider, Stack, styled } from "@mui/material"

export const SummaryBar = styled(Stack)(({ theme: { spacing, palette } }) => ({
  flexDirection: "row",
  gap: spacing(3),
  borderRadius: spacing(0.75),
  border: `4px solid ${palette.primary.light4}`,
  padding: `${spacing(1.5)} ${spacing(3)}`,
}))

export const SummaryBarDivider = styled(Divider)(({ theme: { palette } }) => ({
  backgroundColor: palette.primary.light4,
}))
SummaryBarDivider.defaultProps = {
  flexItem: true,
  orientation: "vertical",
}
